export default {
  labels: {
    today: 'Astăzi',
    pickup_time: 'Ora de ridicare',
    delivery_time: 'Ora de livrare',
  },
};
